import {billsandPaymentsHistoryConstants} from './constants';

export const getbillsandPaymentsHistoryData = (data) => (dispatch) => {
    dispatch({
        type: billsandPaymentsHistoryConstants.BILLS_AND_PAYMENTS_HISTORY_DATA_SUCCESS,
        data: data,
      });
};

export const getbillsandPaymentsHistoryTab = (data) => (dispatch) => {
  dispatch({
      type: billsandPaymentsHistoryConstants.BILLS_AND_PAYMENTS_HISTORY_TAB_SUCCESS,
      data: data,
    });
};